import React from 'react';
import { Grid, Header } from './styles';
import { VitalInput, BloodPressureInput, PulseRhythmInput } from './VitalInput';

const Vitals: React.FC = () => (
  <>
    <Header>Vitals</Header>
    <Grid>
      <VitalInput
        label="Height"
        vitalName="height"
        min={0.25}
        max={3.00}
        unit="m"
        placeholder="0.00"
        decimalPlaces={2}
      />
      <VitalInput
        label="Weight"
        vitalName="weight"
        min={2}
        max={500}
        unit="kg"
        placeholder="00"
        decimalPlaces={1}
      />
      <BloodPressureInput />
      <VitalInput
        label="Tympanic Temperature"
        vitalName="tympanicTemperature"
        min={33}
        max={42}
        unit="°C"
        placeholder="00"
        decimalPlaces={1}
      />
      <VitalInput
        label="Pulse Rate"
        vitalName="pulseRate"
        min={30}
        max={200}
        unit="bpm"
        placeholder="00"
        decimalPlaces={0}
      />
      <VitalInput
        label="Peak Flow Rate"
        vitalName="peakFlowRate"
        min={2}
        max={800}
        unit="L/min"
        placeholder="00"
        decimalPlaces={0}
      />
    </Grid>
    <PulseRhythmInput />
  </>
);

export default Vitals;
